import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const Footer = ({ className = "bg-light text-dark" }) => {
  return (
    <footer className={`py-2 ${className}`}>
      <Container>
        <Row>
          <Col xs={12} md={12}>
           <div className="text-center text-md-left"> 
            Copyright &copy; {new Date().getFullYear()} New York City Public Schools. Note: This application relies on machine translation.
            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
